module.exports = __webpack_public_path__ + "img/jcb.3d18424d.svg";